import firstMeetingImage from '../../assets/images/events/first-meeting.jpg';
import ieeeSecretsImage from '../../assets/images/events/ieee-secrets.png';
import leadershipWorkshopImage from '../../assets/images/events/leadership-workshop.png';
import designThinkingWorkshopImage from '../../assets/images/events/design-thinking-workshop.png';
import fincanceWorkshopImage from '../../assets/images/events/finance-workshop.png';
import publicSpeakingImage from '../../assets/images/events/public-speaking-workshop.jpg';
import digitalMarketingImage from '../../assets/images/events/digital-marketing-workshop.jpg';
import pitchingWorkshopImage from '../../assets/images/events/pitching-workshop.png';
import charityEventImage from '../../assets/images/events/charity-event.jpg';

const events = [
    {
        title: 'First Meeting',
        content:
            "Wow, what an incredible first meeting! We're still buzzing from all the excitement and energy in the room. A huge shoutout to everyone who joined us and made it such a success.",
        // date: '25th November, 2023',
        image: firstMeetingImage,
    },
    {
        title: 'IEEE Secrets',
        content:
            "Unlock the secrets of IEEE! Discover hidden opportunities, amazing travel grants, and more exciting surprise with the WIE chairwoman 'Sahar Youssef' and the IAS chairwoman 'Rahma Jerbi' and get ready to be amazed.",
        // date: '21st Auguest, 2023',
        image: ieeeSecretsImage,
    },
    {
        title: 'Leadership workshop',
        content: `Throwback to February, 8 2023 where we hosted our first session in the entrepreneurship bootcamp.<br/>
				It was a session about leadership presented by DR. Sondos Fadhloun.<br/>
				In this training, we learned a lot about leadership and how to become a successful leader.<br/>
				The trainer taught us many strategies and methods to help us quit our comfort zone and begin our leadership trip.<br/>
				We made fun with our IEEE WIE members, and we loved the way the trainer changed a lot of our mindsets.<br/>
				It was a funny and fruitful workshop.
				`,
        // date: '8th February, 2023',
        image: leadershipWorkshopImage,
    },
    {
        title: 'Design Thinking workshop',
        content: `Throwback to February, 14 where we hosted our second session of our Entrepreneurship workshops series.
				In this training, the IEEE WIE members know a lot about Design thinking as the first and most essential part of beginning any project.
				Our dear Trainer helped us to learn the steps of this cycle and explained new entrepreneurship terms.
				Special thanks to Mr Ahmed Ben Hsouna for this amazing session.
				`,
        // date: '4th December, 2022',
        image: designThinkingWorkshopImage,
    },
    {
        title: 'Finance workshop',
        content: `Throwback to February, 21 where we hosted our third session of the entrepreneurship bootcamp. In this workshop, the IEEE WIE members know a lot about how to finance project basics.
				Our dear Trainer taught us the most important and essential finance knowledge in order to begin planning for a project.
				He shared with us many valuable examples and real prototypes.
				It was a must attending training.
				Special thanks to Mr Aymen Bouzgarrou for this amazing session and to 4C-ISSATSousse.
				`,
        // date: '21st February, 2022',
        image: fincanceWorkshopImage,
    },
    {
        title: 'Public speaking workshop',
        content: `Throwback to February, 27 where we hosted our fourth session of the entrepreneurship bootcamp.
				In this original workshop, our dear coach helped us develop our public speaking skills. He gave us insight into how to prepare for a presentation and introduced us to different types of speaking styles, tones, and volumes. We went through various simulations related to speaking in front of groups and communicating information clearly and effectively, creating an emotional connection with your audience.
				Special thanks to Mr Yousri Ben Mostpha for this amazing session and to 4C-ISSATSousse.`,
        // date: '27th February, 2022',
        image: publicSpeakingImage,
    },
    {
        title: 'Digital Marketing workshop',
        content: `Throwback to the first of March 2023 where we hosted another session in the entrepreneurship bootcamp.
				In this very informative and helpful session, our dear coach taught us the process of digital marketing and the differences between traditional and digital. He shared with us multiple examples.
				A special thanks to Mr Amine Bouffrikha for this amazing workshop and for all his efforts.`,
        // date: '27th February, 2022',
        image: digitalMarketingImage,
    },
    {
        title: 'Pitching workshop',
        content: `Throwback to the second of March 2023 where we hosted the final session in our entrepreneurship boot camp.
					In this workshop, the IEEE WIE members learned methods and tips in order to become able to pitch a project idea in front of an audience.
					Moreover, they made a lot of fun while practicing with our dear trainer.
					A special thanks to Mr.Mohamed Kamoun for this amazing workshop and for all his efforts.
					This workshop was efficient and funny as well.
					`,
        // date: '25th November, 2023',
        image: pitchingWorkshopImage,
    },
    {
        title: 'Charity event',
        content: `
        On the 27th day of Ramadan, the IEEE WIE joined hands with the Sight Chapter and the Student Branch and we organized a remarkable initiative that aimed to bring together our community in support of underprivileged families.<br/>
        During the event, we set up donation stations at two prominent locations,Aziza_Cité aouina Sousse: Mizouu and Monoprixx gloulou sousse whose teams spared no efforts to help us and were very welcoming and cheerful we are so grateful and thankful to you. We are overwhelmed by the kindness and generosity shown by individuals. It was truly heartening to witness the outpouring of compassion as people graciously contributed to our cause.<br/>
        Your donations have played a crucial role in uplifting the lives of those in need by participating in the Ramadan Charity event, We have demonstrated the true power of giving, even the smallest acts of generosity can have a lasting effect.<br/>
        We express our deepest gratitude to each and every person who contributed to this noble cause 🤝✨
        `,
        image: charityEventImage,
    },
    {
        title: 'Wie Gather',
        content: `We are delighted to announce our momentous collaboration 🔥🥳 for the upcoming event WIE GATHER to enhance women in engineering<br/>
        Together we aim to fooster an inclusive environment where inspiring engineering can connect trougth series of workshops, inspiring keynote speakers.`,
        image: null,
    },
];

export default events;
